import axios from 'axios';
import { setServerData } from '../../framework/store/ServerData/ServerDataActions';

export const refreshCaptcha = (data) => (dispatch, getState) => {
    const { serverData = {} } = getState();
    return axios
        .request({
            method: 'get',
            url: 'refreshCaptcha',
            data
        })
        .then(response => {
            dispatch(setServerData({captchaImgUrl: response.data.captchaImgUrl,
                captchaAudioUrl: response.data.captchaAudioUrl }));

        });


};
